import { api } from '../../../helpers'
import { appConstants } from '../../../constants'

export const fetchPopular = () => {
  return dispatch => {
    dispatch(loadPopularRequest())
    api.get('web/article/filterBy/populair?limit=14&page=1')
      .then((res) => {
        const { data: popular, message, success } = res.data
        if (success === 'true') {
          dispatch(loadPopularSuccess(popular))
        } else {
          dispatch(loadPopularFailed(message))
        }
      })
      .catch((message) => loadPopularFailed(message))
  }
}

const loadPopularRequest = () => ({
  type: appConstants.GET_POPULAR_REQUEST
})

const loadPopularSuccess = (popular) => ({
  type: appConstants.GET_POPULAR_SUCCESS,
  payload: { popular }
})

const loadPopularFailed = (message) => ({
  type: appConstants.GET_POPULAR_FAILED,
  payload: { message }
})
